import type { DeviceState } from './mutations';

export default {
  activeDevice(state: DeviceState) {
    return state.activeDevice;
  },
  activeTimerange(state: DeviceState){
    return state.timeRange;
  },
  activeDataType(state: DeviceState) {
    return state.dataType;
  },
  deviceData: (state: DeviceState) => (type: string) => {
    switch (type) {
      case "temperature":
        return state.deviceData.temperature;
      case "humidity":
        return state.deviceData.humidity;
      case "pressure":
        return state.deviceData.pressure;
      case "co2":
        return state.deviceData.co2;
      case "tvoc":
        return state.deviceData.tvoc;
      case "radar":
        return state.deviceData.radar;
      case "rssi":
        return state.deviceData.rssi;
      case "lqi":
        return state.deviceData.lqi;
      default:
        return null;
    }
  },
  deviceTimestamps(state: DeviceState) {
    return state.deviceData.timestamps;
  },
  removeForceResponse(state: DeviceState) {
    return state.removeForceResponse;
  },
  responseOnDeviceInfo(state: DeviceState) {
    return state.responseOnDeviceInfo;
  },
  responseOnJoinState(state: DeviceState) {
    return state.responseOnJoinState;
  },
  responseOnGatewayInfo(state: DeviceState) {
    return state.responseOnGatewayInfo;
  },
  responseOnDeviceSettings(state: DeviceState) {
    return state.responseOnDeviceSettings;
  },
  responseOnAlarmsHistory(state: DeviceState) {
    return state.responseOnAlarmsHistory;
  },
  responseOnTelemetryHistory(state: DeviceState) {
    return state.responseOnTelemetryHistory;
  },
  responseOnAlarmSeen(state: DeviceState) {
    return state.responseOnAlarmSeen;
  },
  responseOnAlarmDismissed(state: DeviceState) {
    return state.responseOnAlarmDismissed;
  },
  responseOnReadBorderRouterData(state: DeviceState) {
    return state.responseOnReadBorderRouterData;
  },
  responseOnReadRoomSensorData(state: DeviceState) {
    return state.responseOnReadRoomSensorData;
  },
  responseOnAlarmsHistoryPerUser(state: DeviceState) {
    return state.responseOnAlarmsHistoryPerUser;
  },
};


